module.exports = __webpack_public_path__ + "img/5.747e5e99.png";